import React from "react";

const GetInTouch = ({ heading, message, email }) => {
  return (
    <div id="getintouch" className="py-3">
      <h2 className="display-4 pb-2 text-center text-white">{heading}</h2>
      <p
        className="lead text-center mx-auto pb-3"
        style={{ maxWidth: "760px", color: "rgba(255, 255, 255, 0.84)" }}
      >
        {message}
      </p>

      <div
        className="mx-auto px-3 px-md-4 pb-2 rounded"
        style={{
          maxWidth: "760px",
        }}
      >
        <div className="row g-3 justify-content-center">
          <div className="col-md-8 col-lg-6">
            <a
              href={`mailto:${email}`}
              className="d-block w-100 text-decoration-none text-center"
              style={{
                color: "#fff",
                padding: "14px 16px",
                borderRadius: "12px",
                border: "1px solid rgba(76, 201, 240, 0.35)",
                backgroundColor: "rgba(76, 201, 240, 0.12)",
              }}
            >
              <small style={{ opacity: 0.72 }}>Email</small>
              <div style={{ fontWeight: 600 }}>{email}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
